import axios from 'axios';
import { Coordinates } from '../../../../types/types';

export const GetElevationDataApi = async (points: Coordinates[]) => {
    /*points is an array of lat lng objects */
    // const coordinates = points.map((point: any) => `${point.lat},${point.lng}`).join('|');
    const coordinates = points.map((point) => ({
        latitude: point.lat,
        longitude: point.lng,
    }));

    console.log('api payload points: ', coordinates);

    try {
        // const response = await axios.get(`https://api.open-elevation.com/api/v1/lookup?locations=${coordinates}`);
        // const response = await axios.get(`http://localhost/api/v1/lookup?locations=${coordinates}`);
        const response = await axios.post('http://localhost/api/v1/lookup', { locations: coordinates });

        console.log('elevation api response: ', response);

        return response.data.results;
    } catch (error) {
        console.log('elevation api error: ', error);
        return null;
    }
    // setCoordsWithElevation(response.data.results);
};

// const elevations = response.data.results.map((result: any, index: number) => ({
//     ...points[index],
//     elevation: result.elevation,
// }));
